import { render, staticRenderFns } from "./OrderSelectedCompany.vue?vue&type=template&id=75c15823&"
import script from "./OrderSelectedCompany.vue?vue&type=script&lang=js&"
export * from "./OrderSelectedCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports